export default "__VITE_ASSET__D61fp3rx__"